import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/findAllWithInternals`;

export const ROUTE: RouteDefinition = `${baseRoute}/findAllWithInternals`;

export const URL = (): RouteDefinition => `${baseRoute}/findAllWithInternals`;
